import { useEffect } from "react";
import { useLocation } from "react-router";

const COOKIE_NAME = "titanskip_ref";
const COOKIE_DAYS = 90;

/**
 * Captures `?ref=<username>` from the current URL and writes it to a cookie
 * scoped to the apex `.titanskip.com` so the panel (app.titanskip.com) reads
 * it on signup.
 *
 * Re-runs on every client navigation, so refs in deep-link URLs *and* in
 * mid-session redirects are both caught. Last write wins.
 *
 * SSR-safe — all DOM access lives inside useEffect.
 *
 * Call once at the root of the app.
 */
export function useReferralCapture() {
  const { search } = useLocation();

  useEffect(() => {
    const ref = new URLSearchParams(search).get("ref");
    if (!ref) return;

    const expires = new Date(
      Date.now() + COOKIE_DAYS * 86_400_000
    ).toUTCString();

    // In production we want the cookie shared with the panel via the apex
    // domain. In local dev we omit Domain so the browser writes a host-only
    // cookie (Domain=.titanskip.com on localhost is silently rejected).
    const isProd = window.location.hostname.endsWith("titanskip.com");
    const domain = isProd ? "; Domain=.titanskip.com" : "";
    const secure = window.location.protocol === "https:" ? "; Secure" : "";

    document.cookie =
      `${COOKIE_NAME}=${encodeURIComponent(ref)}` +
      `; Path=/; Expires=${expires}${domain}; SameSite=Lax${secure}`;
  }, [search]);
}
